import { render } from "./Sala1It.vue?vue&type=template&id=6980af05"
import script from "./Sala1It.vue?vue&type=script&lang=js"
export * from "./Sala1It.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\marco\\Desktop\\archeo-guida-smart\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__